module.exports = __webpack_public_path__ + "static/media/sign-up-img-6.38a9a510.png";